
import { IconButton, Stack } from '@mui/material';
import { Cancel, CheckCircle } from '@mui/icons-material';
import Model from '../models/model';

const CiResultButton = ({ inputProps }) => {
	const { formik, activeRecord } = inputProps;
	return (
		<Stack direction="row" spacing={2} sx={{
			'& .MuiIconButton-root': {
				'&.IsSelected': {
					backgroundColor: (theme) => theme.palette.divider,
				}
			}
		}}>
			<IconButton color="success" className={parseInt(activeRecord.record.WasherCIResult) === 1 ? 'IsSelected' : ''} onClick={() => {
				formik.setFieldValue('WasherCIResult', 1);
				formik.setFieldValue('WasherCIResultIcon', 1);
				activeRecord.record.WasherCIResult = 1;
				activeRecord.record.WasherCIResultIcon = 1;

			}}>
				<CheckCircle fontSize='inherit' />
			</IconButton>
			<IconButton color="error" className={parseInt(activeRecord.record.WasherCIResult) === 2 ? 'IsSelected' : ''} onClick={() => {
				formik.setFieldValue('WasherCIResult', 2);
				formik.setFieldValue('WasherCIResultIcon', 2);
				activeRecord.record.WasherCIResult = 2;
				activeRecord.record.WasherCIResultIcon = 2;

			}}>
				<Cancel fontSize='inherit' />
			</IconButton>
		</Stack>
	)
}
const model = new Model({
	name: 'Cycle',
	showGridRefreshBtn: true,
	onFormLoad: ({ formik, activeRecord }) => {
		if (activeRecord.record.WasherCIResult === 0) {
			formik.setFieldValue('WasherCIResultIcon', undefined);
		}
	},
	customizeSaveData: (toSave, { activeRecord }) => {
		const { record, combos } = activeRecord;
		toSave.WasherCIResult = record.WasherCIResultIcon;
		toSave.id = record.id;
		const lotNumber = combos?.CleaningIndicator?.find((data) => data.DisplayValue === toSave.WasherCILotNumber);
		toSave.WasherCILotNumber = lotNumber ? lotNumber.id : toSave.WasherCILotNumber;
		return toSave;
	},
	columns: [
		{
			header: 'CILotNumber', field: 'WasherCILotNumber', lookup: 'CleaningIndicator',
		},
		{ header: 'CIResult', field: 'WasherCIResultIcon', customizeInput: CiResultButton, required: true, type: 'number' },
	]
});

export const WasherCiResultTable = model;
export default model.createFormBase();
